import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deleteImageFile, updateImageFile, clearMessage } from '../../redux/actions/imageActions';
import dayjs from 'dayjs';


class ShowImageInfo extends Component {
    state = {
        alt: null,
        note: null,
        showEdit: false,
    };
    componentWillReceiveProps(nextProps) {
        if(!nextProps.submit) {
            this.setState({
                alt: null,
                note: null,
            })
        }
    }
    sizeFormat = (size) =>
    { 
        if(size<1024) 
        { 
            return size + " bytes"; 
        } 
        else if(size<(1024*1024)) 
        { 
            size=Math.round(size/1024,1); 
            return size + " KB"; 
        } 
        else if(size<(1024*1024*1024)) 
        { 
            size=Math.round(size/(1024*1024),1); 
            return size + " MB"; 
        } 
        else 
        { 
            size=Math.round(size/(1024*1024*1024),1); 
            return size + " GB"; 
        }
    }
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    };
    handleSubmit = () => {
        const data_image = {
            alt: this.state.alt ? this.state.alt : this.props.image.alt ? this.props.image.alt : '',
            note: this.state.note ? this.state.note : this.props.image.note ? this.props.image.note : '',
        }
        this.props.updateImageFile(data_image, this.props.image.image_fileId, this.props.image_index);
        this.setState({showEdit: false})
    }
    handleEdit = () => {
        this.setState({
            showEdit: !this.state.showEdit,
        })
        this.props.clearMessage();
    }
    handleConfirmDel = () => {
        this.setState({
            confirmDel: !this.state.confirmDel,
        })
    }
    delThisImage = () => {
        const image_fileId = this.props.image.image_fileId;
        const image_index = this.props.image_index;
        this.props.deleteImageFile(image_fileId, image_index);
        this.setState({ 
            alt: null,
            note: null,
            showEdit: false,
            confirmDel: false,
        });
        this.props.handleShowDel(image_index);
    }
    render() {
        const {image, message, submit} = this.props;
        const {alt, note, showEdit, confirmDel} = this.state;
        return (
            <div className="p-15">
                <h4 className="mb-10">CHI TIẾT ĐÍNH KÈM</h4>
                <img src={image.image} alt={image.name} width="30%" height="auto" />
                <p><strong>{image.name}</strong></p>
                <p>{image.createdAt ? dayjs(image.createdAt).format('DD/MM/YYYY') : 'Không xác định'}</p>
                <p>Dung lượng: {image.size ? this.sizeFormat(image.size) : 'Không xác định'}</p>
                <p>Định dạng: {image.extension ? image.extension : 'Không xác định'}</p>
                {confirmDel ? 
                <div className="flex">
                    <div className="text-link-danger mr-20" onClick={this.delThisImage}>Đồng ý</div>
                    <div className="text-link-dark" onClick={this.handleConfirmDel}>Huỷ</div>
                </div>
                : <div className="text-link-danger" onClick={this.handleConfirmDel}>Xoá</div>}
                <hr />
                <p>Sao chép liên kết</p>
                <div className="form-control">
                    <input 
                    type="text" 
                    name="image"
                    className="input-control dark fullWidth"
                    value={image.image ? image.image : 'Ảnh bị lỗi'}
                    disabled
                    />
                </div>
                <p>Thẻ thuộc tính (Alt)</p>
                {
                    showEdit ?
                    <div className="form-control">
                        <input 
                        type="text" 
                        name="alt"
                        className="input-control dark fullWidth"
                        value={alt ? alt : image.alt ? image.alt : ''}
                        onChange={this.handleChange}
                        />
                    </div>
                    :
                    <div className="form-control">
                        <input 
                        type="text" 
                        name="alt"
                        className="input-control dark fullWidth"
                        value={image.alt ? image.alt : ''}
                        disabled
                        />
                    </div>
                }
                <p>Văn bản chú thích</p>
                {showEdit ?
                <div className="form-control">
                    <textarea 
                    type="text" 
                    name="note"
                    className="input-control dark fullWidth"
                    value={note ? note : image.note ? image.note : ''}
                    onChange={this.handleChange}
                    />
                </div>
                :
                <div className="form-control">
                    <textarea 
                    type="text" 
                    name="note"
                    className="input-control dark fullWidth"
                    value={image.note ? image.note : ''}
                    disabled
                    />
                </div>
                }
                {message && 
                    <div className="box-alert-dark mb-15">
                        {message}
                    </div>
                }
                {
                submit ?
                <div className="text-link-dark"><i className="fas fa-spinner fa-pulse mr-10" /> Đang gửi...</div>
                : showEdit ?
                <div className="text-link-dark" onClick={this.handleSubmit}>Lưu thay đổi</div>
                :
                <div className="text-link-dark" onClick={this.handleEdit}>Sửa</div>
                }
            </div>
        )
    }
}

ShowImageInfo.propTypes = {
    deleteImageFile: PropTypes.func.isRequired,
    updateImageFile: PropTypes.func.isRequired,
    clearMessage: PropTypes.func.isRequired,
  }
  
  const mapStateToProps = state => ({
    message: state.image_forders.message,
    submit: state.image_forders.submit,
    image: state.image_forders.image,
    image_index: state.image_forders.image_index,
  })
  
export default connect(mapStateToProps, { deleteImageFile, updateImageFile, clearMessage })(ShowImageInfo);
